import $ from 'jquery';
import { Dropdown, Tooltip } from 'foundation-sites';


const submenuCol = document.querySelectorAll('.js-submenu-width');

// When the document has loaded all the assets
window.addEventListener('load', function() {
  if (submenuCol) {
    submenuCol.forEach((submenuEl) => {
      const submenuChildrenCount = submenuEl.childElementCount;

      if (submenuChildrenCount > 5) {
        const submenuChildWidth = submenuEl.firstElementChild.offsetWidth;
        const submenuElTotalWidth = submenuChildWidth * 2;
        submenuEl.style.width = submenuElTotalWidth + 'px';
      }
    })
  }

  // Dealer Tooltip
  const tooltip = $('.js-dealer-tooltip');
  if (tooltip.length) {
    const tooltipOptions = {
      showOn: 'large',
      position: 'bottom',
      alignment: 'right',
    };
    const tooltipEl = new Tooltip(tooltip, tooltipOptions);
  }

  // Lang dropdown
  const dropdown = $('.js-dropdown');
  if (dropdown.length) {
    const dropdownOptions = {
      parentClass: 'nav-extras__lang',
      hover: true,
      hoverPane: true,
      position: 'bottom',
      alignment: 'right',
      hoverDelay: 100
    };
    const dropdownEl = new Dropdown(dropdown, dropdownOptions);
  }
});

